import { applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';

import Tickets from './custom/tickets';
import General from './custom/general';
import Users from './custom/users';
import Refill from './custom/refill';
import Updates from './custom/updates';

const createMiddlewares = (history) => applyMiddleware(
  routerMiddleware(history),
  thunk,
  Tickets,
  General,
  Users,
  Refill,
  Updates,
);

export default createMiddlewares;
